import { createI18n } from 'vue-i18n'
import { DEFAULT_LOCALE } from './locales'
import en from './messages/en'
import fr from './messages/fr'
import es from './messages/es'
import de from './messages/de'
import pt from './messages/pt'

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, fr, es, de, pt }
})

export default i18n
